<template>
  <div class="protocol-authorization-page">
    <div class="page-header">
      <h2>协议授权记录</h2>
      <p>记录用户阅读、同意与撤回操作</p>
    </div>

    <table-template
      ref="authorizationTable"
      :queryParams="queryParams"
      actionUrl="/businessAgreement/findAgreementRecordList.action"
    >
      <template slot="search">
        <div class="search-panel">
          <el-input
            v-model.trim="queryParams.keyword"
            clearable
            placeholder="搜索用户昵称、手机号或协议名称"
            @keyup.enter.native="search"
          />
          <el-button type="primary" @click="search">查询</el-button>
        </div>
      </template>

      <template slot="item">
        <el-table-column label="用户信息" min-width="180">
          <template slot-scope="scope">
            <div class="primary-text">{{ scope.row.nickName || '-' }}</div>
            <div class="secondary-text">{{ scope.row.phone || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="协议/版本" min-width="190">
          <template slot-scope="scope">
            <div class="primary-text">{{ scope.row.agreementName || '-' }}</div>
            <div class="secondary-text">{{ scope.row.versionNo || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="协议类型" width="120">
          <template slot-scope="scope">{{ agreementTypeText(scope.row.agreementType) }}</template>
        </el-table-column>
        <el-table-column label="阅读并同意时间" min-width="170">
          <template slot-scope="scope">{{ formatAgreeTime(scope.row.readAgreeTime) }}</template>
        </el-table-column>
        <el-table-column label="设备与IP" min-width="260">
          <template slot-scope="scope">
            <div>{{ deviceInfo(scope.row) }}</div>
            <div class="secondary-text">IP {{ scope.row.ip || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="签署入口" min-width="120">
          <template slot-scope="scope">{{ signEntryText(scope.row.signEntry) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="isActive(scope.row) ? 'success' : 'info'" size="small">
              {{ isActive(scope.row) ? '有效' : '已撤回' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="110" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="isActive(scope.row)"
              v-confirm
              type="text"
              confirm-text="确定撤回该用户的协议授权？"
              requestUrl="/businessAgreement/revokeAuthorization.action"
              :confirm-data="{ id: scope.row.id, createUserId: getLoginAccountId() }"
              @onConfirm="onAuthorizationRevoked"
            >撤回授权</el-button>
            <span v-else class="secondary-text">-</span>
          </template>
        </el-table-column>
      </template>
    </table-template>
  </div>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  name: 'protocolAuthorization',
  components: { TableTemplate },
  extends: BasicPager,
  data () {
    return {
      queryParams: {
        keyword: ''
      }
    }
  },
  methods: {
    search () {
      this.$refs.authorizationTable.search()
    },
    isActive (row) {
      return String(row.status) === '1'
    },
    signEntryText (signEntry) {
      const entryMap = {
        '1': '首页中部弹窗',
        '2': '用户注册登录'
      }
      return entryMap[String(signEntry)] || '-'
    },
    agreementTypeText (agreementType) {
      const typeMap = {
        '1': '用户协议',
        '2': '隐私政策',
        '3': '出口协议'
      }
      return typeMap[String(agreementType)] || '-'
    },
    deviceInfo (row) {
      return [row.deviceModel, row.osVersion, row.clientVersion]
        .filter(item => item)
        .join(' · ') || '-'
    },
    formatAgreeTime (value) {
      if (value === null || value === undefined || value === '') return '-'
      return this.getDateTimeByUnixTime(value)
    },
    onAuthorizationRevoked () {
      this.$message.success('协议授权已撤回')
      this.$refs.authorizationTable.search()
    }
  }
}
</script>

<style scoped>
.protocol-authorization-page { padding: 24px; }
.page-header { margin-bottom: 20px; }
.page-header h2 { margin: 0 0 8px; color: #303133; font-size: 24px; }
.page-header p { margin: 0; color: #909399; }
.search-panel { display: flex; gap: 12px; margin: 0 20px 20px 0; padding: 20px; background: #fff; border: 1px solid #ebeef5; border-radius: 4px; }
.search-panel .el-input { flex: 1; }
.primary-text { color: #303133; font-weight: 600; line-height: 24px; }
.secondary-text { color: #909399; line-height: 22px; }
</style>
